export interface GameServerStats {
  players?: number;
  players_online?: number;
  player_by_origin?: {
    fire: number;
    water: number;
    earth: number;
    air: number;
  };
  total_lands?: number;
  wallet_stats?: {
    wallet: string;
    accounts: number;
    assigned_nfts: number[];
  };
  error?: unknown;
  deposit_ratio?: number;
}
export interface GameServer {
  id: number;
  group: string;
  address: string;
  name: string;
  web3: number;
  chain_id: number;
  status: GameServerStatus;
  players_limit: number;
  season_start: number;
  season_finish: number;
  created: null;
  stats: GameServerStats;
  max_ga_per_user: number | null;
  deposit_ratio: {
    base: number;
    incr: number;
    interval: number;
    max: number;
  };
  buyin_sdt: number;
  type: ServerType;
}

export enum ServerType {
  Standard = 0,
  ClickerApp = 10,
}

export interface GetGameServersResponse {
  servers: GameServer[];
}

//* Keep order
export enum GameServerStatus {
  Online = 'online',
  Finished = 'finished',
  Offline = 'offline',
}
